<template>
	<svg
		v-if="themeLight"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		:width="width"
		:height="height"
		class="icon"
		:class="{ 'icon--active': active }"
	>
		<path
			d="M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zm0-15.7l-.8-.8c-1.4-1.4-3.6-1.3-5 0-1.4 1.4-1.4 3.7 0 5.1l5.8 5.9 5.8-5.9c1.4-1.4 1.4-3.7 0-5.1-1.4-1.4-3.6-1.3-5 0l-.8.8z"
		/>
	</svg>
	<svg
		v-else
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		:width="width"
		:height="height"
	>
		<path
			d="M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zm0-15.7l-.8-.8c-1.4-1.4-3.6-1.3-5 0-1.4 1.4-1.4 3.7 0 5.1l5.8 5.9 5.8-5.9c1.4-1.4 1.4-3.7 0-5.1-1.4-1.4-3.6-1.3-5 0l-.8.8z"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconHeart',
	props: {
		themeLight: {
			type: Boolean,
			default: true,
			required: false,
		},
		active: {
			type: Boolean,
			default: false,
		},
		height: {
			type: Number,
			default: 24,
		},
		width: {
			type: Number,
			default: 24,
		},
	},
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/all.scss';

.icon {
	transition: all 0.3s ease-in-out;

	path {
		fill: $white;
	}

	&--active {
		path {
			fill: $primary;
		}
	}
}
</style>
